import { useHistory } from "react-router-dom";

export const useRedirect = (path: string) => {
  const history = useHistory();

  return history.push(path);
};

export default useRedirect;
